/** @jsxImportSource @emotion/core */
import { css } from '@emotion/core';
import React, { useMemo } from 'react';

import { Flex } from 'components/styled';
import Text from 'components/styled/Text';
import Link from 'components/styled/Link';
import AspectRatio from 'components/styled/AspectRatio';

import { useUserToken } from 'auth';

import logoPlaceholder from 'assets/company-avatar-placeholder.png';

import { getFile } from 'api/fileApi';

import { isAdminUser } from 'auth/token';

import { isOfferActive } from 'utils/UASHelpers';

import { OfferDto } from 'typing/endpoints';

type Props = {
	offer: OfferDto;
	tileVariant: string;
	hideLogo?: boolean;
};

const OfferTileHeader: React.FC<Props> = ({ offer, hideLogo, tileVariant }) => {
	const { id, company, title, customTitle } = offer;
	const companyLogo = getFile(company?.logo) ?? logoPlaceholder;
	const isActive = useMemo(
		() =>
			tileVariant === 'inactive'
				? false
				: tileVariant === 'search' || isOfferActive(offer),
		[offer, tileVariant],
	);

	const token = useUserToken();
	const isAdmin = isAdminUser(token);
	return (
		<>
			{tileVariant !== 'inactive' ? (
				<Link to={`/offer/${id}`} width="100%">
					<Flex
						width={1}
						justifyContent="space-between"
						alignItems="flex-start"
					>
						<Flex flexDirection="column" mr={3}>
							{!hideLogo && tileVariant !== 'editable' && (
								<Text fontSize="sm">{company?.name}</Text>
							)}
							<Text fontWeight="bold" my={0}>
								{title?.name ?? customTitle ?? '<<Nepojmenovaná pozice>>'}
							</Text>
						</Flex>

						{/* Company logo */}
						{!hideLogo && tileVariant !== 'editable' && (
							<AspectRatio
								ratio={[1, 1]}
								width="25%"
								flexShrink={0}
								css={css`
									background-image: url(${companyLogo});
									background-size: cover;
									background-repeat: no-repeat;
									background-position: center;
									border-radius: 50%;

									${!isActive &&
									css`
										filter: grayscale();
									`}
								`}
							/>
						)}
					</Flex>
				</Link>
			) : (
				<>
					{isAdmin ? (
						<Link to={`/offer/${id}`} width="100%">
							<Flex
								width={1}
								justifyContent="space-between"
								alignItems="flex-start"
							>
								<Flex flexDirection="column" mr={3}>
									<Text fontWeight="bold" my={0}>
										{title?.name ?? customTitle ?? '<<Nepojmenovaná pozice>>'}
									</Text>
								</Flex>
							</Flex>
						</Link>
					) : (
						<Flex
							width={1}
							justifyContent="space-between"
							alignItems="flex-start"
						>
							<Flex flexDirection="column" mr={3}>
								<Text fontWeight="bold" my={0}>
									{title?.name ?? customTitle ?? '<<Nepojmenovaná pozice>>'}
								</Text>
							</Flex>
						</Flex>
					)}
				</>
			)}
		</>
	);
};

export default OfferTileHeader;
